import Experience from "../../Experience";
import EventEmitter from "../../Utils/EventEmitter";
import Axis from "./Axis";
import * as THREE from 'three'

export default class Axes extends EventEmitter {
    constructor(sphere) {
        super()
        this.experience = new Experience()
        this.scene = this.experience.scene


        this.sphere = sphere

        this.axesData = [
            {
                name: 'east',
                direction: new THREE.Vector3(1, 0, 0),
                taste: 'sweet'
            },
            {
                name: 'west',
                direction: new THREE.Vector3(-1, 0, 0),
                taste: 'sour'
            },
            {
                name: 'north',
                direction: new THREE.Vector3(0, 1, 0),
                taste: 'salty'
            },
            {
                name: 'south',
                direction: new THREE.Vector3(0, -1, 0),
                taste: 'spicy'
            },
            {
                name: 'center',
                direction: new THREE.Vector3(0, 0, 0),
                taste: 'umami'
            }
        ]

        const tasteValues = window.tasteValues;

        this.axes = this.createAxes()


    }
    checkInitialValues() {
        const tasteValues = window.tasteValues;

        if (tasteValues) {
            this.setValues([tasteValues.suess, tasteValues.sauer, tasteValues.salzig, tasteValues.scharf, tasteValues.umami])
        } else {
            this.setValues([0,0,0,0,0])
        }
    }
    show() {
        this.axes.forEach(axis => {
            axis.show()
        })
    }
    
    setValues(values) {
        const data = []

        for (let i = 0; i < values.length; i++) {
            const name = this.axesData[i].name
            const value = values[i]
            data.push({ name, value })
        }
        this.trigger('axesChanged', [data])
    }



    createAxes() {
        const axes = [];
        for (let i = 0; i < this.axesData.length; i++) {

            const axis = new Axis(this.axesData[i], this.sphere);
            axis.on('valueChanged', (value) => {
                // this.trigger('axisValueChanged', [value])
            })


            axes.push(axis);
        }
        return axes;
    }
}

